// ACL - Access Control List

// pages can be available for all users, or for specific userTypes or userRoles

const _pagesAllowedForAllUsers = [
  'dashboard',
  'user-profile',
  'user-schedule',
  'user-absent',
  'user-skills',
  'time',
  'logout',
  'time-mobile',
  'chat'
]
const _pagesAllowedForAllUsersWithPlanner = ['task']
const _pagesAllowedForAllUsersWithExpenses = ['internal-expenses']
const _pagesAllowedOnlyForFullUsersWithPlanner = [
  'projectview-planner',
  'projectview-task',
  'planner',
  'plannertask'
]
const _pagesAllowedOnlyForAdmins = [
  'setting-user', 'setting-subscription',
  'setting-paymentfailed',
  'setting-project'
]
const _pagesAllowedOnlyForAdminsAndPM = [
  'setting-pdftemplate',
  'estimate',
  'estimate-view'
]

const _plannerV2Permissions = [
  'create:planner',
  'read:planner',
  'update:planner',
  'delete:planner'
]

// Roles are - Project Management, Finance, Account owner, Standard
// Role types are - Full user, Standard user

let _userRoleType = ''
let _userRoles = []
let _bPlannerAllowed = true
let _bInternalExpensesAllowed = false
let _bPlannerV2Allowed = false

function _resetRoles () {
  _userRoleType = ''
  _userRoles = []
  _bPlannerAllowed = false
  _bPlannerV2Allowed = false
  _bInternalExpensesAllowed = false
}

function _setFeaturesToTrue () {
  _bPlannerAllowed = true
  _bInternalExpensesAllowed = true
}

function _setUserRoles (roleType, roles) {
  _userRoleType = roleType

  if (roleType === 'Standard user') {
    _userRoles = ['Standard']
  } else {
    _userRoles = roles || []
  }
}

function _getUserRoles () {
  return _userRoles
}

function _isFullUser () {
  return _userRoleType === 'Full user'
}

function _isStandardUser () {
  return _userRoleType === 'Standard user'
}

function _isRoleAdmin () {
  return _hasUserRole('Account owner')
}

function _isRoleProjectManager () {
  return _hasUserRole('Project Management') || _hasUserRole('Account owner')
}

function _isRoleFinance () {
  return _hasUserRole('Finance')
}

function _isRoleStandard () {
  return _hasUserRole('Standard')
}

function _hasUserRole (role) {
  return _userRoles.includes(role)
}

function _isPageAllowed (pageIdent, param1) {
  if (pageIdent === 'planner-v2') {
    return _bPlannerV2Allowed
  }

  // Internal Expenses tab is allowed to view through ident only if it is enabled
  if (_pagesAllowedForAllUsersWithExpenses.includes(pageIdent)) {
    return _isInternalExpensesAllowed()
  }

  // Tasks are allowed to view through ident only if it is enabled
  if (_pagesAllowedForAllUsersWithPlanner.includes(pageIdent)) {
    return _isPlannerAllowed()
  }

  // Standard user
  // Allowed only Dashboard-  My Tasks/My Time/My Projects, Time tracking,
  // User profile/schedule/skills
  if (_isRoleStandard()) {
    return _pagesAllowedForAllUsers.includes(pageIdent)
  } else {
    if (_pagesAllowedOnlyForFullUsersWithPlanner.includes(pageIdent)) {
      return _isPlannerAllowed()
    }

    // Estimate and setting pdf-template are allowed only for Admin, Project Management
    if (_pagesAllowedOnlyForAdminsAndPM.includes(pageIdent)) {
      return _isRoleProjectManager()
    }

    // Manage Users, Subscription, project settings only allowed for Admin
    if (_pagesAllowedOnlyForAdmins.includes(pageIdent)) {
      return _isRoleAdmin()
    }

    if (
      pageIdent === 'report-view' &&
      param1 === 'planner-overview' &&
      !_isPlannerAllowed()
    ) {
      return false
    }
  }

  return true
}

function _isProjectReopenAllowed () {
  return _isRoleAdmin() || _isRoleFinance()
}

function _isPlannerAllowed () {
  return _bPlannerAllowed
}

function _setPlannerAllowed (bPlannerAllowed) {
  _bPlannerAllowed = bPlannerAllowed
}

function _isPlannerV2Allowed () {
  return _bPlannerV2Allowed
}

function _isInternalExpensesAllowed () {
  return _bInternalExpensesAllowed
}

function _setInternalExpensesAllowed (bInternalExpensesAllowed) {
  _bInternalExpensesAllowed = bInternalExpensesAllowed
}

function _setPermissions (permissions) {
  if (!Array.isArray(permissions)) return null

  if (permissions.some(permission => _plannerV2Permissions.includes(permission))) {
    _bPlannerV2Allowed = true
  }
}

const Acl = {}
Acl.setUserRoles = _setUserRoles
Acl.getUserRoles = _getUserRoles
Acl.hasUserRole = _hasUserRole
Acl.isFullUser = _isFullUser
Acl.isStandardUser = _isStandardUser
Acl.isRoleAdmin = _isRoleAdmin
Acl.isRoleProjectManager = _isRoleProjectManager
Acl.isRoleFinance = _isRoleFinance
Acl.isRoleStandard = _isRoleStandard
Acl.isPageAllowed = _isPageAllowed
Acl.isReopenAllowed = _isProjectReopenAllowed
Acl.isPlannerAllowed = _isPlannerAllowed
Acl.setPlannerAllowed = _setPlannerAllowed
Acl.isInternalExpensesAllowed = _isInternalExpensesAllowed
Acl.setInternalExpensesAllowed = _setInternalExpensesAllowed
Acl.resetRoles = _resetRoles
Acl.setFeaturesToTrue = _setFeaturesToTrue
Acl.pagesAllowedForAllUsers = _pagesAllowedForAllUsers
Acl.pagesAllowedForAllUsersWithExpenses = _pagesAllowedForAllUsersWithExpenses
Acl.pagesAllowedForAllUsersWithPlanner = _pagesAllowedForAllUsersWithPlanner
Acl.pagesAllowedOnlyForFullUsersWithPlanner = _pagesAllowedOnlyForFullUsersWithPlanner
Acl.pagesAllowedOnlyForAdmins = _pagesAllowedOnlyForAdmins
Acl.pagesAllowedOnlyForAdminsAndPM = _pagesAllowedOnlyForAdminsAndPM
Acl.setPermissions = _setPermissions
Acl.isPlannerV2Allowed = _isPlannerV2Allowed

export default Acl
